import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/webimports-dev/htdocs/web-imports/src/app/servicos/manutencao-eletronicos/ManutencaoEletronicosPage.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/webimports-dev/htdocs/web-imports/src/components/ui/ServicePageWrapper.tsx");
